import { Coord } from "../../types/Interface";

export default function getCoord(sCoord: Coord, r: number, radian: number): Coord {
  const x = Number((sCoord.x + Math.cos(radian) * r).toFixed(2));
  const y = Number((sCoord.y + Math.sin(radian) * r).toFixed(2));
  return { x, y }
}